import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";
import CustomSelect from "./CustomSelect";
import { Button, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import moment from "moment-jalali";
import { List, PlusCircle, Search } from "react-bootstrap-icons";
import { areDatesEqual } from "../store/api/CommonFunctions";


/**
 * @component
 * @param {object} props
 * @param {[]} props.defaultFilters
 * @param {[{key:string, label:string, type:'date' |'text' |'select' |'textButton', width:int, options:{dataSource:[{value:object, text:string}], valueMember:string, displayMember:string}, displayValue:text, onButtonClick:function}]} props.filterOptions - options for type "select" , displayValue, onButtonClick for type "textButton" 
 * @param {[]} props.filters
 * @param {function} props.setFilters
 * @returns 
 */
export default function DynamicFilters({ defaultFilters, filterOptions, filters, setFilters }) {
    const [selectedFilter, setSelectedFilter] = useState("");
    const [filterValue, setFilterValue] = useState("");
    // const [filters, setFilters] = useState([]);
    const selectRef = useRef();
    const inputFilter = useRef();
    const textTimeout = useRef();
    // وقتی فرم لود میشه، فیلترهای پیش‌فرض رو بیار
    useEffect(() => {
        if (defaultFilters?.length > 0) {
            setFilters(defaultFilters);
        }
        setFilterValue("");
    }, [defaultFilters, selectedFilter]);

    const handleAddFilter = (filterValue) => {
        if (!selectedFilter || !filterValue?.value) return;

        const option = filterOptions.find((f) => f.key === selectedFilter);

        setFilters((prev) => [
            ...prev.filter((f) => f.key !== selectedFilter), // جلوگیری از تکراری
            { key: selectedFilter, label: option.label, value: filterValue.value, text: filterValue.text },
        ]);
        setSelectedFilter("");
        setFilterValue("");
        selectRef.current.open();
    };
    const onSelectFilterType = (val) => {
        setSelectedFilter(val);
        setTimeout(() => {
            if (inputFilter.current?.input) {
                inputFilter.current.input.focus();
            }
            else {
                inputFilter.current?.focus();
            }
        }, 4)


    }
    const onInputKeyDown = (e) => {

        if (e.key !== "Enter") {
            return;
        }
        e.preventDefault();
        if (textTimeout.current) {
            clearTimeout(textTimeout.current);
        }
        handleAddFilter({ value: e.target.value });
    }
    const handleRemove = (key) => {
        setFilters((prev) => prev.filter((f) => f.key !== key));
    };


    const onTextButton = (val) => {

    }
    const onTextChange = (e) => {
        if (textTimeout.current) {
            clearTimeout(textTimeout.current);
        }
        setFilterValue({ value: e.target.value });
        textTimeout.current = setTimeout(() => {
            handleAddFilter({ value: e.target.value });
        }, 6000);
    }
    const onSelectChange = (e) => {
        const option = filterOptions.find(f => f.key === selectedFilter);
        const fv = {
            value: e.target.value,
            text: option.options.dataSource.find(opt => opt.value?.toString() === e.target.value?.toString())?.text ?? ""
        };
        //setFilterValue();
        handleAddFilter(fv);
    }
    const onDateChange = (value) => {
        const fv = { value: value.local("en").format("YYYY-MM-DD"), text: value.local("fa").format("jYYYY/jMM/jDD") };
        const f = filters.find(f => f.key === selectedFilter);
        if (fv.value !== (f?.value ?? ""))
            handleAddFilter(fv);
    }
    return (
        <div className="rowBorder mt-3">
            <div className="rowTitle">
                فیلترهای جستجو
            </div>
            <Row style={{ margin: 0 }}>
                {/* انتخاب نوع فیلتر */}
                <Col md={2} className="p-1 m-0 form-group">
                    <CustomSelect
                        className="form-control"
                        ref={selectRef}
                        value={selectedFilter}
                        onChange={onSelectFilterType}
                        options={[{ value: "", label: "انتخاب فیلتر..." }, ...filterOptions.sort((a, b) => a.label.localeCompare(b.label)).map(f => ({ value: f.key, label: f.label }))]}
                        placeholder="انتخاب فیلتر..."
                    />
                </Col>
                {/* نمایش input بر اساس نوع */}
                {selectedFilter && (() => {
                    const option = filterOptions.find(f => f.key === selectedFilter);
                    if (!option) return null;

                    if (option.type === "text") {
                        return (
                            <Col md={option.width} className="p-1 m-0 form-group">
                                <input
                                    type="text"
                                    onKeyDown={onInputKeyDown}
                                    ref={inputFilter}
                                    value={filterValue?.value ?? ""}
                                    onChange={onTextChange}
                                    className="form-control"
                                />
                                {/* <Button className="btn-input-tiny" onClick={handleAddFilter} style={{ top: 11, left: 6 }}>
                                    <PlusCircle size={23} />
                                </Button> */}
                            </Col>
                        );
                    }
                    if (option.type === "textButton") {
                        return (
                            <Col md={option.width} className="p-1 m-0 form-group">
                                <input className="form-control" value={filterValue?.text ?? ""} onKeyDown={onInputKeyDown} />
                                <Button className="btn-input-tiny" style={{ top: 8, left: 6 }} onClick={option.onButtonClick}><List size={18} /></Button>
                                {/* برای این حالت نیاز به دکمه افزودن نیست چون عمل کلیک خودش باید اضافه هم بکند */}
                            </Col>
                        )
                    }

                    if (option.type === "select") {
                        return (
                            <Col md={option.width} className="p-1 m-0 form-group">
                                <select
                                    value={filterValue?.value ?? ""}
                                    ref={inputFilter}
                                    onChange={onSelectChange}
                                    className="form-control"
                                >
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(option.options?.dataSource) &&
                                        option.options.dataSource.map((opt, i) => <option key={i} value={opt[option.options.valueMember]}>{opt[option.options.displayMember]}</option>)
                                    }
                                </select>
                                {/* <Button className="btn-input-tiny" onClick={handleAddFilter} style={{ top: 11, left: 6 }}>
                                    <PlusCircle size={23} />
                                </Button> */}
                            </Col>
                        );
                    }

                    if (option.type === "date") {
                        return (
                            <Col md={option.width} className="p-1 m-0 form-group">
                                <DatePicker
                                    ref={inputFilter}
                                    onKeyDown={onInputKeyDown}
                                    isGregorian={false} timePicker={false}
                                    value={filterValue?.value ? moment(filterValue.value) : null}
                                    onChange={onDateChange}
                                    className="form-control"
                                    setTodayOnBlur={false}
                                />
                                {/* <Button className="btn-input-tiny" onClick={handleAddFilter} style={{ top: 11, left: 6 }}>
                                    <PlusCircle size={23} />
                                </Button> */}
                            </Col>
                        );
                    }

                })()}
                {/* لیست فیلترهای انتخاب‌شده */}

            </Row>

            <div className={`d-flex flex-wrap gap-1 fs-6 p-1`}>
                {filters.map((f) => (
                    <label
                        key={f.key}
                        className="badge bg-secondary d-flex align-items-center fw-normal"
                    >
                        {f.label}: {f.text ?? f.value}&nbsp;
                        <FontAwesomeIcon
                            icon={faTimes}
                            size="lg"
                            onClick={() => handleRemove(f.key)}
                        />
                    </label>
                ))}
            </div>
        </div>
    );
}
